import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5 10a1.667 1.667 0 11-3.334 0A1.667 1.667 0 015 10zM11.666 10a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0zM16.666 11.667a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334z",
    fill: "#000",
    fillOpacity: 0.54
  }));
}
export default SvgComponent;